/**
 * Veilcaster (168) deploy: coalesce weapon steal flies into one sequential batch per steal.
 */
export function coalesceVeilcasterWeaponStealFlyBatch(grants) {
  if (!grants?.length) {
    return [];
  }

  const passthrough = [];
  const stealGroups = new Map();

  grants.forEach((grant) => {
    if (grant?.source !== 'veilcaster_168' || !grant?.key) {
      passthrough.push(grant);
      return;
    }
    const keyParts = String(grant.key).split(':');
    if (keyParts.length < 4) {
      throw new Error(`coalesceVeilcasterWeaponStealFlyBatch: invalid grant key ${grant.key}`);
    }
    const veilcasterInstanceId = keyParts[1];
    const targetInstanceId = keyParts[2];
    const groupKey = `${veilcasterInstanceId}:${targetInstanceId}:${grant.fromZone}:${grant.fromIndex}:${grant.toZone}:${grant.toIndex}`;
    if (!stealGroups.has(groupKey)) {
      stealGroups.set(groupKey, []);
    }
    stealGroups.get(groupKey).push(grant);
  });

  stealGroups.forEach((group) => {
    const sorted = [...group].sort(
      (a, b) => (a.sequenceIndex ?? 0) - (b.sequenceIndex ?? 0)
    );
    if (sorted.length === 1) {
      passthrough.push(sorted[0]);
      return;
    }
    const keyParts = String(sorted[0].key).split(':');
    const veilcasterInstanceId = keyParts[1];
    const targetInstanceId = keyParts[2];
    const batchWeaponInstanceIds = sorted.map((g) => String(g.weaponInstanceId));
    passthrough.push({
      ...sorted[0],
      key: `veilcaster-batch:${veilcasterInstanceId}:${targetInstanceId}:${batchWeaponInstanceIds.join('_')}`,
      batchGrants: sorted,
      batchWeaponInstanceIds,
    });
  });

  return passthrough;
}
